export default __webpack_public_path__ + "static/media/contact-img.27d9dbdf.jpg";